/* eslint-disable no-console */
import { createAsyncThunk } from '@reduxjs/toolkit';
import ordersMasterService from '../../services/orders/ordersMasterService';

import { retryFn } from '../../utils';
import { OrderDataForPlaceOrder } from './types';
import { CartInStore } from '../cart/types';

export const placeOrder = createAsyncThunk(
  'order/placeOrder',
  async (
    { orderData }: { orderData: OrderDataForPlaceOrder },
    { getState, rejectWithValue },
  ) => {
    try {
      console.log({
        title: 'PlaceOrder Thunk called with:',
        message: JSON.stringify(orderData),
        encodeMessageInBase64: true,
      });

      const { cart } = getState() as { cart: CartInStore };
      const cartId = cart.id;
      console.log({
        title: 'PlaceOrder Thunk cartId:',
        message: cartId,
      });

      // eslint-disable-next-line prefer-destructuring
      const isDraft = cart.isDraft;
      console.log({
        title: 'PlaceOrder Thunk isDraft:',
        message: isDraft,
      });

      return await (retryFn({
        fn: ordersMasterService.callToMethod,
        args: {
          cartId,
          isDraft,
          methodName: ordersMasterService.methodsMap.placeOrder,
          paramsObject: {
            ...orderData,
          },
        },
        retriesLeft: +(
          process.env.PAYMENTJS_TOKENIZATION_RESULT_QUERY_MAX_ATTEMPTS ?? '0'
        ),
        delayTime: +(
          process.env.PAYMENTJS_TOKENIZATION_RESULT_QUERY_DELAY_MS ?? '0'
        ),
      }) as Promise<void>);
    } catch (error) {
      console.log({
        title: 'CheckoutError:',
        message: `placeOrder - ${JSON.stringify(error, Object.getOwnPropertyNames(error))}`,
        encodeMessageInBase64: true,
      });

      return rejectWithValue({
        errorCode: JSON.stringify(error),
      });
    }
  },
);
